define(function(require, exports, module) {
    'use strict';
    const cashierConfig = require('portlets/cashier/cashier.config');

    /**
     * Represents cashier config for all methods or chosen type+method
     * @param {string} [aspect] - 'method.methodType' selector for method and method type; Both parts are optional
     * @returns Object
     */
    module.exports = function(aspect) {
        const config = cashierConfig(aspect);
        const nonGenericAspects = ['CashViaSC', 'RetailDeposit', 'ApplePayEPG'];

        if (nonGenericAspects.includes(aspect)) {
            return {
                isGeneric: false
            };
        }

        return config;
    };
});
